import { InitCookie } from '@patsnap/init-cookie';
import { getBrowserFingerprint } from './browser-fingerprint';

export class InitCookieService {
    async init() {
        const fromParam = new URLSearchParams(window.location.search).get('from') || new URLSearchParams(window.location.hash.split('?')[1] || '').get('from');
        const cookie = new InitCookie({
            // 访客ID，优先使用cookie中的visitor_id，如果没有则使用浏览器指纹
            // @ts-ignore
            visitor_id: InitCookie.getVisitorId() || getBrowserFingerprint(),
            entry_channel: InitCookie.getEntryChannel() || 'rd_triz',
            campaign_name: fromParam || InitCookie.getCampaignName() || 'rd_triz',
        });
        return await cookie.init();
    }
}

export const initCookieService = new InitCookieService();
